import React from 'react'
import PropTypes from 'prop-types'
import { FormattedNumber } from 'belle-js'
import classnames from 'classnames'

import styles from './DonutTooltip.module.scss'

const DonutTooltip = (props) => {
  const {
    classAllocation,
    tooltipStyles,
    showTooltip,
  } = props
  const tooltipClasses = classnames(
    styles.d3__tooltip,
    styles[`d3__tooltip--${classAllocation.type}`],
  )
  return showTooltip && classAllocation  && (
    <div className={styles.DonutTooltip} data-test-id="donutTooltip">
      <div className={tooltipClasses} style={tooltipStyles}>
        <p>
          {classAllocation.value.toString()}% {classAllocation.name}
        </p>
        <span className={styles.label}>
          <FormattedNumber
            value={classAllocation.totalEmv}
            format="currencyWithDecimal"
            showNegativeSign={false} />
        </span>
      </div>
    </div>
  )
}

DonutTooltip.propTypes = {
  classAllocation: PropTypes.object,
  showTooltip: PropTypes.bool,
  tooltipStyles: PropTypes.object,
}

DonutTooltip.defaultProps = {
  classAllocation: {},
  showTooltip: false,
  tooltipStyles: {},
}

export default DonutTooltip



// WEBPACK FOOTER //
// ./src/components/Client/PortfolioDonut/DonutTooltip/DonutTooltip.jsx